<div class="stats-grid">

  <div class="stats-card total">

    <div>
      <p>Total Requisitions</p>
      <h2>{{ stats.total }}</h2>
    </div>

    <mat-icon>
      analytics
    </mat-icon>

  </div>

  <div class="stats-card open">

    <div>
      <p>Open</p>
      <h2>{{ stats.open }}</h2>
    </div>

    <mat-icon>
      folder_open
    </mat-icon>

  </div>

  <div class="stats-card confirmed">

    <div>
      <p>Confirmed</p>
      <h2>{{ stats.confirmed }}</h2>
    </div>

    <mat-icon>
      verified
    </mat-icon>

  </div>

  <div class="stats-card pending">

    <div>
      <p>Sample collected</p>
      <h2>{{ stats.pending }}</h2>
    </div>

    <mat-icon>
      cloud_upload
    </mat-icon>

  </div>

</div>